export interface Category {
  id: string;
  name: string;
  description: string;
  icon: string;
  cover: string;
}

export const categories: Category[] = [
  {
    id: 'portrait',
    name: '人像',
    description: '捕捉人物的神态与情绪，光影之间讲述属于每个人的故事。',
    icon: 'ri-user-smile-line',
    cover: 'https://readdy.ai/api/search-image?query=artistic%20portrait%20photography%20of%20young%20person%20with%20dramatic%20side%20lighting%2C%20warm%20orange%20tones%2C%20shallow%20depth%20of%20field%2C%20creative%20studio%20background%2C%20editorial%20magazine%20style&width=800&height=600&seq=cat-portrait-01&orientation=landscape',
  },
  {
    id: 'landscape',
    name: '风光',
    description: '山川湖海，日出日落，记录大自然最壮丽的瞬间。',
    icon: 'ri-landscape-line',
    cover: 'https://readdy.ai/api/search-image?query=epic%20mountain%20landscape%20photography%20at%20golden%20hour%2C%20warm%20orange%20sky%2C%20layered%20misty%20peaks%2C%20cinematic%20wide%20angle%2C%20consistent%20warm%20tone%20editorial%20style&width=800&height=600&seq=cat-landscape-01&orientation=landscape',
  },
  {
    id: 'macro',
    name: '微距',
    description: '放大细节，发现肉眼难以察觉的微观世界之美。',
    icon: 'ri-focus-3-line',
    cover: 'https://readdy.ai/api/search-image?query=macro%20photography%20of%20water%20droplets%20on%20flower%20petal%2C%20warm%20orange%20bokeh%20background%2C%20extreme%20close%20up%2C%20soft%20natural%20light%2C%20editorial%20product%20style&width=800&height=600&seq=cat-macro-01&orientation=landscape',
  },
  {
    id: 'creative',
    name: '创意',
    description: '打破常规，用镜头表达天马行空的想象力。',
    icon: 'ri-lightbulb-flash-line',
    cover: 'https://readdy.ai/api/search-image?query=surreal%20creative%20photography%20with%20double%20exposure%20effect%2C%20warm%20orange%20and%20gray%20tones%2C%20abstract%20composition%2C%20artistic%20studio%20lighting%2C%20editorial%20magazine%20style&width=800&height=600&seq=cat-creative-01&orientation=landscape',
  },
  {
    id: 'street',
    name: '人文街拍',
    description: '穿梭城市街巷，记录真实而有温度的生活瞬间。',
    icon: 'ri-community-line',
    cover: 'https://readdy.ai/api/search-image?query=street%20photography%20of%20city%20alley%20with%20warm%20evening%20light%2C%20pedestrians%20silhouette%2C%20orange%20toned%20urban%20scene%2C%20documentary%20style%2C%20consistent%20editorial%20tone&width=800&height=600&seq=cat-street-01&orientation=landscape',
  },
  {
    id: 'night',
    name: '夜景',
    description: '霓虹与星空，探索光线在黑夜中的无限可能。',
    icon: 'ri-moon-clear-line',
    cover: 'https://readdy.ai/api/search-image?query=night%20cityscape%20photography%20with%20warm%20orange%20neon%20lights%2C%20long%20exposure%20light%20trails%2C%20dark%20sky%20with%20stars%2C%20cinematic%20urban%20night%20scene%2C%20editorial%20style&width=800&height=600&seq=cat-night-01&orientation=landscape',
  },
];

export const getCategoryById = (id: string) => categories.find((c) => c.id === id);